import { render, staticRenderFns } from "./BlogsView.vue?vue&type=template&id=43729e19&"
import script from "./BlogsView.vue?vue&type=script&lang=js&"
export * from "./BlogsView.vue?vue&type=script&lang=js&"
import style0 from "./BlogsView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports